import { Layout, Zap, Heart, RefreshCw } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ICONS = [Layout, Zap, Heart, RefreshCw];

export function Benefits() {
  const { t } = useLanguage();

  return (
    <section
      id="warum"
      className="py-20 md:py-32 bg-[#020817] relative overflow-hidden"
      data-testid="benefits-section"
    >
      {/* Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[200px] bg-green-500/5 blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            {t.benefits.title}
          </h2>
          <div className="w-16 h-1 bg-cyan-500 mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.benefits.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                data-testid={`benefit-card-${i}`}
                className="group p-6 rounded-xl bg-[#0f172a] border border-slate-800 hover:border-cyan-500/40 hover:shadow-[0_0_20px_rgba(0,188,212,0.08)] transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-cyan-500/10 flex items-center justify-center mb-4 group-hover:bg-cyan-500/20 transition-colors">
                  <Icon className="w-6 h-6 text-cyan-400" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
